/**
 *  update by tannc 2018年12月24日20:33:50
 */

import {
  BOOKNODE_API,
  BOOKNODE_SAVE_API,
  BOOKNODE_REMOVE_API,
  BOOKNODE_ZGK_API,
  BOOKNODE_ZGK_SAVE_API,
  BOOKNODE_ZGK_REMOVE_API,
  BOOKNODE_SJ_API,
  BOOKNODE_SJ_SAVE_API,
  BOOKNODE_SJ_REMOVE_API
} from '../resource/index';
import axios from '../config/axios.config';
export default {

  async save(params) {
    return await axios.save(BOOKNODE_SAVE_API,{},params);
  },
  async fetchData(id) {
    return await axios.get(BOOKNODE_API,{id:id});
  },
  async remove(id){
    return axios.remove(BOOKNODE_REMOVE_API,{id:id})
  },

  // 中高考
  async zgkFetchData(params) {
    return await axios.get(BOOKNODE_ZGK_API, params);
  },
  async zgkSave(params) {
    return await axios.save(BOOKNODE_ZGK_SAVE_API, {}, params);
  },
  async zgkRemove(id){
    return axios.remove(BOOKNODE_ZGK_REMOVE_API, {id: id});
  },

  // 试卷大全
  async sjFetchData(params) {
    return await axios.get(BOOKNODE_SJ_API, params);
  },
  async sjSave(params) {
    return await axios.save(BOOKNODE_SJ_SAVE_API, {}, params);
  },
  async sjRemove(id){
    return axios.remove(BOOKNODE_SJ_REMOVE_API, {id: id});
  }
}



// WEBPACK FOOTER //
// ./src/service/booknodeService.js